export enum PaymentType {
  CARD = 1,
  CASH = 2,
  // Phone takeaways are often paid by Revolut transfer. Added to the
  // payment_types table on 2026-09-21; the enum had never caught up, so the
  // admin could only ever record Card or Cash.
  REVOLUT = 3,
}

export const PaymentTypeLabel: Record<number, string> = {
  [PaymentType.CARD]: 'Card',
  [PaymentType.CASH]: 'Cash',
  [PaymentType.REVOLUT]: 'Revolut',
};
